import {FACILITY_CATEGORY, RESERVATION_ACCEPTABILITY_FOR_RESIDENT} from '../../../CodeMaster'
import {judgeFacilityReserveEditAuthority} from '../helpers/helpers'
import {FilterConditions} from '../ResidentFacilityReservationStatusPage'
import FacilityCardInfo from '../../facilities/FacilityCardInfo'

export const judgeDetailDialogIsViewOnlyMode = (
    facilityResidentReserve: RESERVATION_ACCEPTABILITY_FOR_RESIDENT,
): boolean => {
    return facilityResidentReserve === RESERVATION_ACCEPTABILITY_FOR_RESIDENT.AGENT ||
        !judgeFacilityReserveEditAuthority()
}

interface FilterConditionsForJSON {
    categories: string[]
}

export const serializeFilterConditions = (
    filterConditions: FilterConditions
): string => {
    const {categories} = filterConditions
    const filterConditionsForJson: FilterConditionsForJSON =
        {
            categories: categories && categories.map((category => category.value)),
        }
    return JSON.stringify(filterConditionsForJson)
}

export const deserializeFilterConditions = (
    json: string
): FilterConditions => {
    const filterConditionsForJson: FilterConditionsForJSON = JSON.parse(json)
    const {categories} = filterConditionsForJson
    return {
        categories: categories &&
            categories.map(category => FACILITY_CATEGORY.codeToEnumConstants(category)),
    }
}

export const filterFacilityInfosByTypeAndCategory = (
    facilityInfos: FacilityCardInfo[],
    filterConditions: FilterConditions,
): FacilityCardInfo[] => {
    if (filterConditions.categories.length > 0) {
        const conditionCategories: FACILITY_CATEGORY[] = filterConditions.categories
        return facilityInfos.filter((info) => (
            conditionCategories.includes(info.category)
        ))
    }

    return facilityInfos
}
